import gql from 'graphql-tag';
import { Injectable } from '@angular/core';

import { BackendService } from '../new-http/backend.service';
import { IAvailableCourse } from '../../interfaces/infoproducts/course.interfaces';

@Injectable({ providedIn: 'root' })
export class InfoproductsCourseService extends BackendService {
  /**
   * Busca todos os curso disponíveis
   *
   * @returns
   */
  public async getAvailableCourses(): Promise<IAvailableCourse[]> {
    const { data } = await this.graphqlApi.query({
      fetchPolicy: 'network-only',
      query: gql`
        query {
          availableCourses {
            id
            link
            name
            slug
            tags
            isFree
            slogan
            coverUrl
            accessLink
            mostViewed
            description
            purchasableId
            coverMobileUrl
            trailerVideoUrl
            isAllowedToCustomer
            group {
              id
              name
              description
            }
            pricing {
              current
              promotion
              refundTime
            }
            category {
              id
              name
            }
            bonus {
              name
              title
              descriptionItems
              strategies {
                id
                name
                link
                tags
                accessLink
                coverUrl
                coverMobileUrl
                category {
                  id
                  name
                }
              }
            }
            modules {
              name
              isLocked
              lessons {
                name
                videoDistributionUrl
                description
                resources {
                  url
                  name
                }
                cta {
                  link
                  title
                  subtitle
                }
              }
            }
            descriptors {
              icon
              title
              subtitle
            }
            purchase {
              id
              isTrial
            }
            progress {
              percent
              totalLessons
              completedLessons
            }
            nextLesson {
              moduleId
              lessonId
            }
            teacher {
              name
              about
              heroImageUrl
              profilePhotoUrl
            }
            comments {
              title
              content
              author
            }
          }
        }
      `
    });

    return data.availableCourses;
  }

  public setLessonComplete(
    courseId: string,
    moduleId: number,
    lessonId: number
  ) {
    const data = this.api.post('/infoproduct/progress', {
      courseId,
      moduleId: Number(moduleId),
      lessonId: Number(lessonId)
    });
    return data;
  }
}
